import { TaskState, EditorStateOps } from '@src/editor-helpers'
import { EditorState, DraftEditorCommand, ContentBlock, ContentState } from 'draft-js'
import { Map } from 'immutable'

const mapCommandToSelect = {
  'do-task': 'do',
  'dont-do-task': 'dontdo',
  'timeout-task': 'timeout'
}

export default (editorState: EditorState, command: DraftEditorCommand) => {
  if (['do-task', 'dont-do-task', 'timeout-task'].includes(command)) {
    const taskState = TaskState.fromEditorState(editorState)
    const selection = editorState.getSelection()
    const currentBlock = EditorStateOps.getFocusBlock(editorState)
    const currentTask = TaskState.getTaskByKey(taskState, currentBlock.get('key'))
    const decisionKey = TaskState.getDecisionBlockKey(currentTask)
    const contentState = editorState.getCurrentContent()
    const decisionBlock = contentState.getBlockForKey(decisionKey)
    const existData = decisionBlock.get('data').toJS()
    let data

    let selected
    selected = mapCommandToSelect[command]

    if (existData.selected && existData.selected === selected) data = { ...existData, selected: null }
    else data = { ...existData, selected }

    const newBlock = decisionBlock.merge({ data: Map(data) }) as ContentBlock

    const newContentState = contentState.merge({
      blockMap: contentState.getBlockMap().set(decisionBlock.getKey(), newBlock)
    }) as ContentState

    let newEditorState = EditorState.push(editorState, newContentState, 'change-block-data')

    newEditorState = EditorState.forceSelection(newEditorState, selection)

    return newEditorState
  } else {
    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/components/RemarksApplicationRoot/handleTaskDecisionCommand.ts